import type { PdfPreviewResponse } from "../api";

export function getPreviewImageSrc(content: string): string {
  if (content.startsWith("data:") || content.startsWith("http")) {
    return content;
  }

  const mime = content.startsWith("/9j/") ? "image/jpeg" : "image/png";
  return `data:${mime};base64,${content}`;
}

export function mapPdfPreviewsResponse(data: Pick<PdfPreviewResponse, "pageCount" | "previews">) {
  const firstPreview = data.previews?.[0];

  return {
    pageCount: data.pageCount ?? 0,
    previewSrc: firstPreview?.content ? getPreviewImageSrc(firstPreview.content) : null,
  };
}
